import { render } from "./App.vue?vue&type=template&id=68006305&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=68006305&scoped=true&lang=css"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68006305"]])

export default __exports__